import { ArrowDropDown } from "@material-ui/icons";
import { Button, Menu, MenuItem, ListSubheader } from "@material-ui/core";
import AddIcon from '@material-ui/icons/Add';
import React, { useState } from "react";
import { inject, observer } from "mobx-react";
import LabelVideoStore from "store/labelVideoStore";
import { uniqueId } from "lodash";

interface Props {
  labelVideoStore?: LabelVideoStore;
  onPause?: () => void;
}

const AddIncidentButton = ({ labelVideoStore, onPause }: Props) => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

  const handleMenuClick = (event: React.MouseEvent<HTMLElement>) => {
    onPause?.();
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  const handleIncidentTypeSelect = (incidentClass: any) => {
    labelVideoStore?.setIncidents([
      ...labelVideoStore?.incidents,
      {
        id: uniqueId(),
        startFrame: labelVideoStore?.currentFrame,
        endFrame: null,
        label: "Incident ",
        startTime: labelVideoStore?.currentTime,
        endTime: null,
        isFinished: false,
        class: incidentClass,
      },
    ]);
    labelVideoStore?.setClickedIncident(null);
    handleMenuClose();
  };

  return (
    <>
      <Button
        variant="contained"
        color="secondary"
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          paddingLeft: "8px",
          paddingRight: "8px"
        }}
        disabled={labelVideoStore?.incidents.some((inc) => !inc.isFinished)}
        onClick={handleMenuClick}
      >
        <AddIcon style={{ marginRight: "4px" }} />
        Ajouter un label
        <ArrowDropDown style={{ marginLeft: "4px" }} />
      </Button>
      <Menu
        anchorEl={anchorEl}
        keepMounted
        open={Boolean(anchorEl)}
        onClose={handleMenuClose}
      >
        <ListSubheader>Choisir un label</ListSubheader>
        {!labelVideoStore?.incidentClassesLoading && 
        labelVideoStore?.incidentClasses && 
        labelVideoStore?.incidentClasses.length > 0 && 
        labelVideoStore?.incidentClasses.map((incidentClass) => (
          <MenuItem
            key={incidentClass.id}
            onClick={() => handleIncidentTypeSelect(incidentClass)}
          >
            {incidentClass.name}
          </MenuItem>
        ))}
      </Menu>
    </>
  );
};

export default inject("labelVideoStore")(observer(AddIncidentButton));
